import { Expose, Type } from 'class-transformer';
import { BaseModel } from '@core/data-access';

export class CpfWithdrawalModel extends BaseModel {
  @Expose() block!: string;
  @Expose() floor!: string;
  @Expose() unit!: string;
  @Expose() street!: string;
  @Expose() postal!: string;
  @Expose() country!: string;
  @Expose() accruedInterestAmount!: number;
  @Expose() monthlyInstalmentAmount!: number;
  @Expose() principalWithdrawalAmount!: number;
  @Expose() totalCpfAllowedForProperty!: number;
}

/** Provenance MyInfo answered the group with — echoed back unchanged, never edited. */
export class CpfHousingWithdrawalModel extends BaseModel {
  @Expose()
  classification?: string;

  @Expose()
  @Type(() => CpfWithdrawalModel)
  withdrawals?: CpfWithdrawalModel[];

  @Expose()
  lastUpdated?: string;

  @Expose()
  lastUpdatedOnly?: string;

  @Expose()
  source?: string;
}
